// Janela única para registar recebimentos, igual em todo o lado (Comissões, negócio, processos).
// Mostra o mesmo bloco do detalhe do negócio: cartões de resumo, linhas a cinzento com "Receber" e histórico.
import { X } from "lucide-react";
import { ds } from "./desenho";
import RecebimentosNegocio from "./RecebimentosNegocio";

const GRADIENTE = "linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%)";

export default function JanelaRecebimento({ neg, nc, recs, onFechar, ...resto }) {
  return (
    <div role="dialog" aria-modal="true" aria-label="Registar recebimento" onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(10,18,40,.45)", zIndex: 9300, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: 16, overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: ds.fundo || "#F6F7FA", borderRadius: 14, width: 1040, maxWidth: "100%", margin: "auto", overflow: "hidden", fontFamily: ds.letra, color: ds.tinta, boxShadow: "0 12px 40px rgba(10,18,40,.3)" }}>
        <div style={{ background: GRADIENTE, color: "#fff", padding: "14px 20px", display: "flex", alignItems: "center", gap: 10, fontSize: 16, fontWeight: 700 }}>
          <span>Recebimentos{neg.imovel_ref ? " do negócio " + neg.imovel_ref : ""}</span>
          <button onClick={onFechar} aria-label="Fechar" style={{ marginLeft: "auto", background: "transparent", border: 0, color: "#fff", cursor: "pointer", display: "inline-flex" }}><X size={20} aria-hidden="true" /></button>
        </div>
        <div style={{ padding: 16 }}>
          <RecebimentosNegocio neg={neg} nc={nc} recs={recs} autoOpen {...resto} />
        </div>
      </div>
    </div>
  );
}
